import { toString } from 'lodash';
import { useParams } from 'react-router-dom';
import { FilterList } from 'src/components/filterList';
import { Header } from 'src/components/header';
import { PublicationModal } from 'src/components/modal';
import { ViewOnlyAlert } from 'src/components/viewOnlyAlert';
import { PATHS } from 'src/constants/paths';
import { useFilterAndSorting } from 'src/hooks';
import { IFilter } from 'src/interfaces';
import { lang, useUserRole } from 'src/utils';

import { DetailLocationGroupPage } from '../detailLocationGroupPage/DetailLocationGroupPage';
import {
  Container,
  FixedWidthColumn,
  FluidWidthColumn,
  Wrapper,
} from './AssignLocationGroupPage.styled';
import { useLocationGroupAssignPage } from './hooks/AssignLocationGroupPage.hook';
import { AddLocations } from './modules/addLocations/AddLocations';

export const AssignLocationGroupPage = () => {
  const { locationGroupId = '' } = useParams();
  const { isViewOnly } = useUserRole();
  const filters: IFilter[] = [];
  const { onChangeKeyword, onRemoveKeyword, onChangeFilter, onReset } =
    useFilterAndSorting(filters, [], true, () => {}, true);

  const {
    locationGroup,
    publishModal,
    isLocationAdded,
    publicationCloseModal,
    saveLocation,
  } = useLocationGroupAssignPage(locationGroupId);

  if (isLocationAdded) {
    return (
      <>
        <DetailLocationGroupPage />
        {publishModal.open && (
          <PublicationModal
            title={lang.assignLocationModal.title}
            subTitle={lang.assignLocationModal.subTitle}
            confirmText={lang.publish}
            cancelText={lang.close}
            locationGroupIDs={locationGroupId ? [Number(locationGroupId)] : []}
            open={publishModal.open}
            onClose={publicationCloseModal}
            modalSize="sm"
            closeMessage={lang.assignLocationModal.closeMessage}
          />
        )}
      </>
    );
  }

  return (
    <Container>
      <Header
        title={`${lang.assignLocationsTo} ${toString(locationGroup?.name)}`}
        breadcrumbItems={[
          {
            label: lang.locationGroup,
            link: `${PATHS.LOCATION_GROUPS}`,
          },
          {
            label: toString(locationGroup?.name),
          },
        ]}
        actionBar={isViewOnly && <ViewOnlyAlert />}
      />
      <Wrapper>
        <FixedWidthColumn>
          <FilterList
            filters={filters}
            onChangeKeyword={onChangeKeyword}
            onRemoveKeyword={onRemoveKeyword}
            onChangeFilter={onChangeFilter}
            showReset
            onReset={onReset}
          />
        </FixedWidthColumn>
        {!isViewOnly && (
          <FluidWidthColumn>
            <AddLocations
              onSave={saveLocation}
              channelName={locationGroup?.channel_name}
            />
          </FluidWidthColumn>
        )}
      </Wrapper>
    </Container>
  );
};
